import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import Banner from "../components/Banner";
import SliderContainer from "../components/SliderContainer";
import { Footer } from "../Footer";
import axios from "axios";
import { base_url } from "../../context/Authcontext";
import { useNavigate } from "react-router-dom";


const JdbGaming = () => {
  const [isSidebar, setSidebar] = useState(false);
  const navigate= useNavigate();
   



  const latest_games=[

    {
        name: "Galaxy Burst",
        GAMEID: "37ca0b32e1908480e03db00cdc1bc2cf",
        "game_type": "街机游戏",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Galaxy-Burst.png",
        provider:'jdb'
      },
      {
        name: "Mines",
        GAMEID: "45a2a92108634508e5c47c690eb01c0b",
        "game_type": "街机游戏",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mines.png",
        provider:'jdb'
      },
      {
        name: "Plinko",
        GAMEID: "cb54272cd536cf77eb6093bae2513095",
        "game_type": "街机游戏",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Plinko.png",
        provider:'jdb'
      },
      {
        name: "Hilo",
        GAMEID: "9ffbc085919e5e19f93a682fd3a737bb",
        "game_type": "街机游戏",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Hilo.png",
        provider:'jdb'
      },
      {
        name: "Goal",
        GAMEID: "0160b30b64598290365f61211fb84a7b",
        "game_type": "街机游戏",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Goal.png",
        provider:'jdb'
      },
      {
        name: "Firework Burst",
        GAMEID: "19f082ffb4656934e80459a73ab73037",
        "game_type": "街机游戏",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Firework-Burst.png",
        provider:'jdb'
      },
      {
        name: "Dragon Tiger - Joker Bonus",
        GAMEID: "067d540d7ece7e7dfcfcadf11f25a71d",
        "game_type": "棋牌游戏",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Tiger-Joker-Bonus.png",
        provider:'jdb'
      },
      {
        name: "Dice",
        GAMEID: "6aa921aebc8d7e170740cfc8e88426f6",
        "game_type": "街机游戏",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dice.png",
        provider:'jdb'
      },
      {
        name: "Mines2",
        GAMEID: "b1ad7a48e4d4839dbe53fcadf7eb5183",
        "game_type": "街机游戏",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mines2.png",
        provider:'jdb'
      },



]


  const Hot_games=[
    {
        name: "Lucky Diamond",
        GAMEID: "6f6867ad1956a04b174c92629cab7f54",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Diamond.png",
        provider:'jdb'
      },
      {
        name: "Jungle Jungle",
        GAMEID: "6c5fe548bd6e09b683566298b29510ea",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Jungle-Jungle.png",
        provider:'jdb'
      },
      {
        name: "Double Wilds",
        GAMEID: "7bd5233c83de0669336ee649e6c8d2b5",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Double-Wilds.png",
        provider:'jdb'
      },
      {
        name: "Funky King Kong",
        GAMEID: "cdea2d0670bc40309b4a9b6f942a218a",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Funky-King-Kong.png",
        provider:'jdb'
      },
      {
        name: "Dragons World",
        GAMEID: "00b886803f3d067f7028872468e84745",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragons-World.png",
        provider:'jdb'
      },
      {
        name: "Lucky Seven",
        GAMEID: "b560b7c42bd29f7d0cda06485a3c4af5",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Seven.png",
        provider:'jdb'
      },
      {
        name: "Orient Animals",
        GAMEID: "bdb0459f7e116a20839a3b2a0063a2ff",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Orient-Animals.png",
        provider:'jdb'
      },
      {
        name: "Lucky Racing",
        GAMEID: "8b51a987c5c536a894b592ae361d655d",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Racing.png",
        provider:'jdb'
      },
      {
        name: "Dragon",
        GAMEID: "735fcdbf9f5e6042132cc01e9860723f",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon.png",
        provider:'jdb'
      },
      {
        name: "Dragon Warrior",
        GAMEID: "29135c91125ae1655f8c91eb29617705",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Warrior.png",
        provider:'jdb'
      },
      {
        name: "Monkey King",
        GAMEID: "5ecca33d3cabee8cbab8897ce2843459",
        "game_type": "Slot Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Monkey-King.png",
        provider:'jdb'
      },
      {
        name: "Fishing Disco",
        GAMEID: "e453b811fd1782fd2ade1f93ee0dee32",
        "game_type": "Fish Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fishing-Disco.png",
        provider:'jdb'
      },
      {
        name: "Dragon Master",
        GAMEID: "f691d904ea681ce449263f7e9cc47c35",
        "game_type": "Fish Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Master.png",
        provider:'jdb'
      },
      {
        name: "Fishing Yilufa",
        GAMEID: "877c97367d24925a11d342726eb0320f",
        "game_type": "Fish Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fishing-Yilufa.png",
        provider:'jdb'
      },
      {
        name: "Dragon Fishing Ii",
        GAMEID: "6cef8d8ea517d86602db60fe9781b01b",
        "game_type": "Fish Game",
        src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Fishing-Ii.png",
        provider:'jdb'
      },

]
   
  const other_games= 
  [
     {
       name: "Dragon Soar",
       GAMEID: "9341a18d096ad901ef77338998f29098",
       "game_type": "Slot Game",
       src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Soar.png",
       provider:'jdb'
     },
   {
     name: "Pop Pop Candy",
     GAMEID: "fde142e65f14da39f784e9e5325e0a77",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pop-Pop-Candy.png",
     provider:'jdb'
   },
   {
     name: "Open Sesame Mega",
     GAMEID: "cb5e57be0354264c6c7ea0cdf4eb18b3",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Open-Sesame-Mega.png",
     provider:'jdb'
   },
   {
     name: "Fruity Bonanza",
     GAMEID: "f5d6b418b755f3aefe3b9828f3112c9c",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fruity-Bonanza.png",
     provider:'jdb'
   },
   {
     name: "Caishen Coming",
     GAMEID: "45ecec5dd5077785e7a09988b95bbd24",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Caishen-Coming.png",
     provider:'jdb'
   },
   {
     name: "Coocoo Farm",
     GAMEID: "d1f17fd51e474b0e72892332ea551ba1",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Coocoo-Farm.png",
     provider:'jdb'
   },
   {
     name: "Elemental Link Water",
     GAMEID: "b84274cdfa5731945a34bfd0db1ddeea",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Elemental-Link-Water.png",
     provider:'jdb'
   },
   {
     name: "Elemental Link Fire",
     GAMEID: "46016a772b92c7f47dfdc5873f184ef1",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Elemental-Link-Fire.png",
     provider:'jdb'
   },
   {
     name: "Birdsparty Deluxe",
     GAMEID: "786d1cd7f4fa9905c825378292f1204c",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Birdsparty-Deluxe.png",
     provider:'jdb'
   },
   {
     name: "Moneybags Man 2",
     GAMEID: "33c862e7db9e0e59ab3f8fe770f797da",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Moneybags-Man-2.png",
     provider:'jdb'
   },
   {
     name: "Trump Card",
     GAMEID: "96c010fc4a95792401e903213d7add44",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Trump-Card.png",
     provider:'jdb'
   },
   {
     name: "Fortune Neko",
     GAMEID: "49b706ccfe7c53727ee6760cd9a8721a",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fortune-Neko.png",
     provider:'jdb'
   },
   {
     name: "Book Of Mystery",
     GAMEID: "13072a6eb2111c1b5202fe6155227e94",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Book-Of-Mystery.png",
     provider:'jdb'
   },
   {
     name: "Prosperitytiger",
     GAMEID: "1d704bbb187a113229f3fdaa3b5406fe",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Prosperitytiger.png",
     provider:'jdb'
   },
   {
     name: "Glamorous Girl",
     GAMEID: "2663e14e5b455525252a25d9bd99e840",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Glamorous-Girl.png",
     provider:'jdb'
   },
   {
     name: "Blossom Of Wealth",
     GAMEID: "ed6fbaeb7a104dd7ed96fa1683a48669",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Blossom-Of-Wealth.png",
     provider:'jdb'
   },
   {
     name: "Boom Fiesta",
     GAMEID: "1ffb31ff605f1a7862a138f5cd712056",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Boom-Fiesta.png",
     provider:'jdb'
   },
   {
     name: "Big Three Dragons",
     GAMEID: "600c338d3fca2da208f1bba2c9d29059",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Big-Three-Dragons.png",
     provider:'jdb'
   },
   {
     name: "Mayagoldcrazy",
     GAMEID: "6c8009d165293759bb218b72ba3c380f",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mayagoldcrazy.png",
     provider:'jdb'
   },
   {
     name: "Lantern Wealth",
     GAMEID: "f2f2eae301311f0320ef669b68935546",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lantern-Wealth.png",
     provider:'jdb'
   },
   {
     name: "Marvelous Iv",
     GAMEID: "126cf2bfe8a8e606b362d23de02c0d5e",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Marvelous-Iv.png",
     provider:'jdb'
   },
   {
     name: "Wonder Elephant",
     GAMEID: "540da2ba4c849fc1c315f43ae74df220",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Wonder-Elephant.png",
     provider:'jdb'
   },
   {
     name: "Kong",
     GAMEID: "f6e9fd31cbc3be8cd3bd95486177377b",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Kong.png",
     provider:'jdb'
   },
  
   {
     name: "Spindrift 2",
     GAMEID: "05dc8c7a43305c3fcb43574c570d6378",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Spindrift-2.png",
     provider:'jdb'
   },
  
   {
     name: "Dragons Gate",
     GAMEID: "feaba603992f26633116fb54562e3693",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragons-Gate.png",
     provider:'jdb'
   },
   {
     name: "Spindrift",
     GAMEID: "b624d1917ef5a740c151e4904a7cf0dd",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Spindrift.png",
     provider:'jdb'
   },

   {
     name: "Moneybags Man",
     GAMEID: "c4fdebb24ff26fffb3a65d018da8ae92",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Moneybags-Man.png",
     provider:'jdb'
   },
   {
     name: "Miner Babe",
     GAMEID: "e705514fdd4f9bea5f82bbd0b2c0a353",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Miner-Babe.png",
     provider:'jdb'
   },
   {
     name: "Super Niubi Deluxe",
     GAMEID: "5d940d11c48b64ec1e6a3c8be5228250",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Super-Niubi-Deluxe.png",
     provider:'jdb'
   },
 
   {
     name: "Golden Disco",
     GAMEID: "dfb8a198ce0e821560cf543387a2acc2",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Golden-Disco.png",
     provider:'jdb'
   },
   {
     name: "Treasure Bowl",
     GAMEID: "0651af3e73c7600633522ffe15cc175b",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Treasure-Bowl.png",
     provider:'jdb'
   },
   {
     name: "Mjolnir",
     GAMEID: "e270f0674dff538b181499d18ab47845",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mjolnir.png",
     provider:'jdb'
   },
   {
     name: "Pirate Treasure",
     GAMEID: "bfb3241e64953f731e72bc833f2fa79a",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pirate-Treasure.png",
     provider:'jdb'
   },
   {
     name: "Fortune Treasure",
     GAMEID: "5a55a19d9cfbead5e64b8169e96bd27a",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fortune-Treasure.png",
     provider:'jdb'
   },
   {
     name: "Egypt Treasure",
     GAMEID: "b7f39e861e2e02633cb5cb08958f1041",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Egypt-Treasure.png",
     provider:'jdb'
   },
   {
     name: "Super Niubi",
     GAMEID: "4042e5d0c777e1d3c3bd481dac0a867e",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Super-Niubi.png",
     provider:'jdb'
   },
 
   {
     name: "Go Lai Fu",
     GAMEID: "a3584394182e8abce362d90c2f048c75",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Go-Lai-Fu.png",
     provider:'jdb'
   },
   {
     name: "Birds Party",
     GAMEID: "7b497c4d19f87c86ea29910c12129edc",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Birds-Party.png",
     provider:'jdb'
   },
   {
     name: "Triple King Kong",
     GAMEID: "a9f60e017f2765c74e1ec80473ac4ffa",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Triple-King-Kong.png",
     provider:'jdb'
   },
 
  
 
   {
     name: "Mining Upstart",
     GAMEID: "a26bdb5af2cf4964dfb241fbaec09252",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mining-Upstart.png",
     provider:'jdb'
   },
   {
     name: "Rolling In Money",
     GAMEID: "55bfa979698650a3580d169c1469f79c",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Rolling-In-Money.png",
     provider:'jdb'
   },
   {
     name: "Daji",
     GAMEID: "2254bbebab4925c0df6a98d9edcfeec4",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Daji.png",
     provider:'jdb'
   },
   {
     name: "Kingsman",
     GAMEID: "55e3b4d064b014a403be6ffba8c4343e",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Kingsman.png",
     provider:'jdb'
   },
   {
     name: "Street Fighter",
     GAMEID: "528e5d4fda0a34e233a28930783d2c63",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Street-Fighter.png",
     provider:'jdb'
   },

  
   {
     name: "One Punch Man",
     GAMEID: "5aa472006c8698cf6f59dd0548129cda",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/One-Punch-Man.png",
     provider:'jdb'
   },
   {
     name: "Billionaire",
     GAMEID: "16b1418fe87a6fa5628eec8cb40da056",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Billionaire.png",
     provider:'jdb'
   },
   {
     name: "Mr. Bao",
     GAMEID: "8c4681d49251042820069339dee4250c",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mr.-Bao.png",
     provider:'jdb'
   },
   {
     name: "Panda Panda",
     GAMEID: "6652927614dccaf87d8965c509e96f82",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Panda-Panda.png",
     provider:'jdb'
   },
   {
     name: "Legendary 5",
     GAMEID: "04a3be36bbf1110345d53e07df9c9cc3",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Legendary-5.png",
     provider:'jdb'
   },
   {
     name: "Chef Panda",
     GAMEID: "078a7876afc6553fd0c0c9d1cbe0b04a",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Chef-Panda.png",
     provider:'jdb'
   },
   {
     name: "Lucky Fuwa",
     GAMEID: "55946533d07080972b83c4aae1d4be2f",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Fuwa.png",
     provider:'jdb'
   },
  
   {
     name: "Rooster In Love",
     GAMEID: "2f24019dc8abbe05b984611462a1f01c",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Rooster-In-Love.png",
     provider:'jdb'
   },
   {
     name: "Xi Yang Yang",
     GAMEID: "f1496f1b49981a63e6064ac84517b5ae",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Xi-Yang-Yang.png",
     provider:'jdb'
   },
   {
     name: "Fortune Horse",
     GAMEID: "ca6e7b621b13077debbf1bf9d5a6c031",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fortune-Horse.png",
     provider:'jdb'
   },
   {
     name: "Flirting Scholar Tang Ii",
     GAMEID: "857d3426c220b4003cd0e4521c07e94b",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Flirting-Scholar-Tang-Ii.png",
     provider:'jdb'
   },
   {
     name: "Open Sesameii",
     GAMEID: "558ca5b101d1be5bd7a08c6d01422c4f",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Open-Sesameii.png",
     provider:'jdb'
   },
   {
     name: "Winning Mask Ii",
     GAMEID: "955ab46e30fcda3b2446169409848fa7",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Winning-Mask-Ii.png",
     provider:'jdb'
   },
   {
     name: "Guan Gong",
     GAMEID: "90bfd55dcf41709d27f1f38fd4a314a9",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Guan-Gong.png",
     provider:'jdb'
   },
   {
     name: "Beauty And The Kingdom",
     GAMEID: "478d2e337f0d0a1b40e0e3521f89f1ba",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Beauty-And-The-Kingdom.png",
     provider:'jdb'
   },
   {
     name: "Lucky Phoenix",
     GAMEID: "8244e0afc46b2b8a3446ec18ae0e129a",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Phoenix.png",
     provider:'jdb'
   },
   {
     name: "Lucky Miner",
     GAMEID: "8146db6ded1ef29540d262650817d090",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Miner.png",
     provider:'jdb'
   },
   {
     name: "Olympian Temple",
     GAMEID: "ca11d9830495d2888d7e50770353ce32",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Olympian-Temple.png",
     provider:'jdb'
   },
   {
     name: "Mahjong",
     GAMEID: "e9d4b66c06a43e73ec8f1b2055f83c3a",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mahjong.png",
     provider:'jdb'
   },
   {
     name: "Banana Saga",
     GAMEID: "77f407b50f00ec4569249b008a5adca0",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Banana-Saga.png",
     provider:'jdb'
   },
   {
     name: "Open Sesame",
     GAMEID: "d5cede7b6800bd9cd266cde8c4f73dc6",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Open-Sesame.png",
     provider:'jdb'
   },
   {
     name: "Four Treasures",
     GAMEID: "d53f82ab4fbb353480e012fd763bc339",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Four-Treasures.png",
     provider:'jdb'
   },
   {
     name: "Napoleon",
     GAMEID: "e4b973ece238c954fbcdf30fdfeae969",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Napoleon.png",
     provider:'jdb'
   },
   {
     name: "New Year",
     GAMEID: "319fb2a372755ff47f6adc4f36e67b0f",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/New-Year.png",
     provider:'jdb'
   },
   {
     name: "Moonlight Treasure",
     GAMEID: "85e29fa6b578c6bf131ad4fdff750acb",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Moonlight-Treasure.png",
     provider:'jdb'
   },
   {
     name: "Lucky Lion",
     GAMEID: "c1557ea0fad63c5e07b32d9f62ef1899",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Lion.png",
     provider:'jdb'
   },
   {
     name: "Lucky Qilin",
     GAMEID: "f2298bcf0de0dccdd767d30b6e4f811a",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Qilin.png",
     provider:'jdb'
   },
   {
     name: "Formosa Bear",
     GAMEID: "e0afed167c1ef4c9a35c527a52419f0a",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Formosa-Bear.png",
     provider:'jdb'
   },
   {
     name: "The Llama Adventure",
     GAMEID: "6800ef74e2b33c9a9155848f1328c8e5",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/The-Llama-Adventure.png",
     provider:'jdb'
   },
   {
     name: "Wukong",
     GAMEID: "59acc6ad72fd6fb6cf30eb58cd9bedb8",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Wukong.png",
     provider:'jdb'
   },
   {
     name: "Winning Mask",
     GAMEID: "4aebce625a1495532a25344f0e4ac584",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Winning-Mask.png",
     provider:'jdb'
   },
   {
     name: "Flirting Scholar Tang",
     GAMEID: "07df172c089e29e576aa41eeb0cbeb2b",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Flirting-Scholar-Tang.png",
     provider:'jdb'
   },
   {
     name: "Lucky Dragons",
     GAMEID: "c32fff242e09a234f7350bb9aaa055cc",
     "game_type": "Slot Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Dragons.png",
     provider:'jdb'
   },
   {
     name: "Spirit Tide Legend",
     GAMEID: "638d38491dad4a6562713143b1fc6cc1",
     "game_type": "Fish Game",
     src: "https://drive.google.com/drive/folders/1Kspw4eE2ujFhE743nzkl_ZHSKodcYGtE",
     provider:'jdb'
   },
  
 

   {
     name: "Shade Dragons Fishing",
     GAMEID: "89e967a8336fb8caad2c1b6d735588fe",
     "game_type": "Fish Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Shade-Dragons-Fishing.png",
     provider:'jdb'
   },
   {
     name: "Cai Shen Fishing",
     GAMEID: "6df463eabe5fcdaa033e1c89b9ffd162",
     "game_type": "Fish Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Cai-Shen-Fishing.png",
     provider:'jdb'
   },
  
   {
     name: "Dragon Fishing",
     GAMEID: "1145d7cd96518a5ba2f77cb14cb363c4",
     "game_type": "Fish Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Fishing.png",
     provider:'jdb'
   },
 
 
  
  
   
   {
     name: "Jogo Do Bicho",
     GAMEID: "0e8432be6bc0cab304b41bc964aaf154",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Jogo-Do-Bicho.png",
     provider:'jdb'
   },
   {
     name: "Caishen Party",
     GAMEID: "6437f1794f0753b268b2badbd69ef156",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Caishen-Party.png",
     provider:'jdb'
   },
   {
     name: "Lucky Color Game",
     GAMEID: "5708005e9f2340dbd719567a94ba44b4",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Color-Game.png",
     provider:'jdb'
   },
   {
     name: "King Of Football",
     GAMEID: "4088c7ed9db461f990d9514d6b9f7537",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/King-Of-Football.png",
     provider:'jdb'
   },
   {
     name: "Crazy King Kong",
     GAMEID: "c2c611f87d47faae8e4b285fe8145d41",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Crazy-King-Kong.png",
     provider:'jdb'
   },
   {
     name: "Super Super Fruit",
     GAMEID: "a9899c045de7873e620e0ef330f3fc73",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Super-Super-Fruit.png",
     provider:'jdb'
   },
   {
     name: "Huaguoshan Legends",
     GAMEID: "6ff786580f7d9453728b9a8a3d1c3499",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Huaguoshan-Legends.png",
     provider:'jdb'
   },
   {
     name: "Beer Tycoon",
     GAMEID: "b133cf4f3c32b80344b381cc9f26442a",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Beer-Tycoon.png",
     provider:'jdb'
   },
   {
     name: "Birds And Animals",
     GAMEID: "db93ffd7164953bb1eb4c86b68542ed6",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Birds-And-Animals.png",
     provider:'jdb'
   },
   {
     name: "Happy New Year",
     GAMEID: "d0b0d503d3d553643f665d5d2fdab138",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Happy-New-Year.png",
     provider:'jdb'
   },
   {
     name: "Classic Mario",
     GAMEID: "627148e0dd36ff12df432fc920a0c59f",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Classic-Mario.png",
     provider:'jdb'
   },
   {
     name: "Happy Lottery",
     GAMEID: "d6cd29e274d066e2e8f0cb171e7583a8",
     "game_type": "Lottery Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Happy-Lottery.png",
     provider:'jdb'
   },
   {
     name: "Gold Rooster Lottery",
     GAMEID: "2f3361619ef9520214c08fd2aecf33da",
     "game_type": "Lottery Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Gold-Rooster-Lottery.png",
     provider:'jdb'
   },
   {
     name: "Cai Shen Bingo",
     GAMEID: "f3629935719cf04d6b689933486177ce",
     "game_type": "Lottery Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Cai-Shen-Bingo.png",
     provider:'jdb'
   },
   {
     name: "Tongits Rush",
     GAMEID: "3ecfba28c6c8f3ffce6c8134478a6bfa",
     "game_type": "棋牌游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Tongits-Rush.png",
     provider:'jdb'
   },
   {
     name: "Tongits Fight",
     GAMEID: "6996a44ebff8fc97ce19cf791f4916cc",
     "game_type": "棋牌游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Tongits-Fight.png",
     provider:'jdb'
   },
   {
     name: "Pusoy Rush",
     GAMEID: "f03953d954b4ac3809efbedd5dfabec2",
     "game_type": "棋牌游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pusoy-Rush.png",
     provider:'jdb'
   },

   {
     name: "Tongits",
     GAMEID: "47614f18718c2f911b89f00fd053b527",
     "game_type": "棋牌游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Tongits.png",
     provider:'jdb'
   },
   {
     name: "Pusoy",
     GAMEID: "f436610d0255b4e3646603a1e42793b7",
     "game_type": "棋牌游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pusoy.png",
     provider:'jdb'
   },
   {
     name: "Fighter Fire",
     GAMEID: "ff83699bef9b2e773857ed1a9eedc5fb",
     "game_type": "Fish Game",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fighter-Fire.png",
     provider:'jdb'
   },
  
   {
     name: "Mole Crash",
     GAMEID: "a170eb308c8fab8f2a5cdac5b427acbd",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mole-Crash.png",
     provider:'jdb'
   },
   {
     name: "Mines2",
     GAMEID: "b1ad7a48e4d4839dbe53fcadf7eb5183",
     "game_type": "街机游戏",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mines2.png",
     provider:'jdb'
   },
   {
     name: "Pusoy",
     GAMEID: "524ff2b54801f94ada51a1e2b37c593e",
     "game_type": "arcade",
     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pusoy.png",
     provider:'jdb'
   },
 ]


 

  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    
  },[]);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Latest games </span>{" "}
                    <span className="all cursor-pointer" onClick={()=>navigate('/jdbAll')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={latest_games} />
                  </div>
                </div>
                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Hot games </span>{" "}
                    <span className="all cursor-pointer" onClick={()=>navigate('/jdbAll')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={Hot_games} />
                  </div>
                </div>
                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Other Games </span>{" "}
                    <span className="all cursor-pointer" onClick={()=>navigate('/jdbAll')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={other_games} />
                  </div>
                </div>
               
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default JdbGaming;